import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'

import Dashboard from '../Dashboard'

import VisitorsToolbar from './components/VisitorsToolbar'

const Visitors = ({ designSwitch, uiVersion }) => {
  const [analyticsOpen, setAnalyticsOpen] = useState(false)
  const [newVisitorModalOpen, setNewVisitorModalOpen] = useState()

  return (
    <Dashboard.Container className="ctp-visitors">
      <VisitorsToolbar
        analyticsOpen={analyticsOpen}
        setAnalyticsOpen={setAnalyticsOpen}
        setNewVisitorModalOpen={setNewVisitorModalOpen}
        designSwitch={designSwitch}
      />
      <div className="ctp-visitors__inner">
        <Outlet
          context={{ analyticsOpen, newVisitorModalOpen, setNewVisitorModalOpen, uiVersion }}
        />
      </div>
    </Dashboard.Container>
  )
}

Visitors.propTypes = {
  children: PropTypes.node,
  designSwitch: PropTypes.node,
  uiVersion: PropTypes.string,
}

export default connect()(Visitors)
